import { useRouter } from "expo-router";
import React from "react";

import ScrollView from "$src/core/components/atoms/ScrollView/ScrollView";
import Text from "$src/core/components/atoms/Text/Text";
import Grid from "$src/core/components/organisms/Grid";
import useAuth from "$src/core/hooks/use-auth";
import useTabBarHeight from "$src/core/hooks/use-tab-bar-height";
import useTranslation from "$src/core/hooks/use-translation";
import ErrorPage from "$src/core/pages/ErrorPage/ErrorPage";
import LoadingPage from "$src/core/pages/LoadingPage/LoadingPage";
import MessagePage from "$src/core/pages/MessagePage/MessagePage";
import useWatchlistQuery from "$src/core/queries/use-watchlist-query";
import $pageInsets from "$src/core/styles/page";

import $ from "./WatchlistPage.styles";

const WatchlistPage = () => {
  const { t } = useTranslation();
  const { status: statusAuth } = useAuth();
  const router = useRouter();
  const tabBarHeight = useTabBarHeight();

  const { data: watchlist, status, error, refetch } = useWatchlistQuery();

  if (statusAuth !== "authenticated") {
    return (
      <MessagePage
        title={t("ERROR/AUTH/TITLE")}
        subtitle={t("ERROR/AUTH/SUBTITLE")}
        icon="lock"
        ctaText={t("WATCHLIST_PAGE/AUTH_REQUIRED_CTA_LABEL")}
        ctaIcon="sign-in"
        onPressCta={() => router.navigate("/intro")}
      />
    );
  }

  if (status === "pending") {
    return <LoadingPage />;
  }

  if (status === "error") {
    return (
      <ErrorPage
        title={t("ERROR/WATCHLIST_PAGE/TITLE")}
        subtitle={t("ERROR/WATCHLIST_PAGE/SUBTITLE")}
        ctaText={t("COMMON/RETRY")}
        ctaIcon="retry"
        onPressCta={refetch}
        error={error}
      />
    );
  }

  if (watchlist.items.length === 0) {
    return (
      <MessagePage
        icon="folder"
        title={t("WATCHLIST/EMPTY/TITLE")}
        subtitle={t("WATCHLIST/EMPTY/SUBTITLE")}
      />
    );
  }

  return (
    <ScrollView
      style={$.container}
      contentContainerStyle={[
        $pageInsets.vertical({ tabBarHeight }),
        $pageInsets.horizontal,
      ]}
      accessibilityRole="list"
    >
      <Text accessibilityRole="header" preset="heading1" style={$.title}>
        {t("WATCHLIST/TITLE")}
      </Text>

      <Grid items={watchlist.items} />
    </ScrollView>
  );
};

export default WatchlistPage;
